
/**
 * Wrapper around Joi validation to ease the integration with the checklist framework
 * @param {Object} checklist
 * @param {Object} schema
 * @returns {Object|null} errors 
 */
export default function validate(checklist, schema) {
  const result = schema.validate(checklist, { abortEarly: false });
  if (!result || !result.error) {
    return null;
  }
  
  const errors = {};
  result.error.details.forEach(detail => {
    const errorMessages = detail.path && detail.path.length? detail.path.join('.') : '';
    errors[errorMessages.replace('values.', '')] = detail.message;
  });

  return errors;
}
